// Утилиты для российского номера +7 (XXX) XXX-XX-XX
// Жёсткий лимит: 11 цифр (первая 7), маскировка при вводе.

export function digitsOnly(raw) {
  return String(raw || '').replace(/\D/g, '');
}

/** Возвращает только цифры, нормализуя начало (8 → 7, 9XX… → 79XX…). Макс 11 цифр. */
export function normalizeDigits(raw) {
  let d = digitsOnly(raw);
  if (d.startsWith('8') && d.length === 11) d = '7' + d.slice(1);
  if (d.length === 10 && d.startsWith('9')) d = '7' + d;
  if (!d.startsWith('7')) {
    if (d.length === 0) return '';
    if (d[0] !== '7') d = '7' + d;
  }
  return d.slice(0, 11);
}

/** Форматирует в "+7 (XXX) XXX-XX-XX" с прогрессивным заполнением. */
export function formatPhone(raw) {
  const d = normalizeDigits(raw);
  if (d.length === 0) return '';
  const tail = d.slice(1); // без первой "7"
  let out = '+7';
  if (tail.length > 0) out += ' (' + tail.slice(0, 3);
  if (tail.length >= 3) out += ')';
  if (tail.length > 3) out += ' ' + tail.slice(3, 6);
  if (tail.length > 6) out += '-' + tail.slice(6, 8);
  if (tail.length > 8) out += '-' + tail.slice(8, 10);
  return out;
}

/** Готов ли телефон (ровно 11 цифр). */
export function isValidPhone(raw) {
  return normalizeDigits(raw).length === 11;
}

/** Возвращает компактную форму "+7XXXXXXXXXX" — то, что шлём на сервер. */
export function toApiPhone(raw) {
  const d = normalizeDigits(raw);
  return d ? '+' + d : '';
}
